export const asHierarchy = {
  data: `<svg width="16" height="12" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.99984 4.99997H7.33317V6.99993H5.99984V8.66656H4.6665V6.99993H0.666504L0.666504 11.6665H4.6665V9.99987H5.99984V11.6665H9.99984V9.99987H11.3332V11.6665L15.3332 11.6665V6.99993H11.3332V8.66656H9.99984V6.99993H8.6665V4.99997H9.99984V0.3334H5.99984L5.99984 4.99997ZM1.99984 10.3332L1.99984 8.33324H3.33317V10.3332H1.99984ZM13.9998 8.33324V10.3332H12.6665V8.33324H13.9998ZM8.6665 8.33324V10.3332H7.33317V8.33324H8.6665ZM8.6665 1.66671V3.66667L7.33317 3.66667V1.66671H8.6665Z"/>
  </svg>
  `,
  name: 'hierarchy',
};
